import './winmock6/style';
import FormStructure from './winmock6/form_structure';

export default FormStructure;